import { fromJS } from 'immutable';

import { LOAD_CLIENT_PAYMENTS_SUCCESS, UPDATE_CLIENT_PAYMENT_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  dataset: [],
  pagination: {
    totalCount: null,
    pageCount: null,
    currentPage: null,
    perPage: null,
  },
});

const paymentTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_CLIENT_PAYMENT_SUCCESS:
      return state.set('dataset', state.get('dataset').unshift(action.invoice.invoiceId));
    case LOAD_CLIENT_PAYMENTS_SUCCESS:
      return state.merge(
        fromJS({
          dataset: action.clientPayments.items.map((invoice) => invoice.invoiceId),
          pagination: {
            totalCount: action.clientPayments._meta.totalCount,
            pageCount: action.clientPayments._meta.pageCount,
            currentPage: action.clientPayments._meta.currentPage,
            perPage: action.clientPayments._meta.perPage,
          },
        }),
      );
    default:
      return state;
  }
};

export default paymentTableReducer;
